// extracted by mini-css-extract-plugin
module.exports = {"insightSummaryRoot":"l2HCKLV0","insightCardWrapper":"jbA13jo8","titleRow":"NUwt_a6L","title":"bSZZTtpB","footerText":"jzHXlFM_"};